import styled from 'styled-components';

export const ActionsWrapper = styled.div``